import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from "@material-ui/core/Button";
import TreeItem from "@material-ui/lab/TreeItem";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import copy from 'copy-to-clipboard';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
	maxWidth: "100%",

    "& .MuiTextField-root": {
      width: "100%"
    }
  }
}));

export default function OPCUATree() {
  const [fetching, setFetching] = useState(false);
  const [nodeId, setNodeId] = useState("");
  const [browseName, setBrowseName] = useState("");
  const [nodeClass, setNodeClass] = useState("");
  const [typeDefinition, setTypeDefinition] = useState("");
  const [dataType, setDataType] = useState("");
  const [dataValue, setDataValue] = useState("");
  const [tree, setTree] = useState("");
  const [endpointURL, setEndpointURL] = useState(
    "opc.tcp://localhost:4840/api/v1.0/OPCUA/cedalo/machineserver"
  );
  const classes = useStyles();

  useEffect(() => {}, []);

  const handleEndpointURLChange = event => {
    const { value } = event.target;
    setEndpointURL(value);
  };

  const updateDetails = event => {
    if (event.target.dataset.json) {
      try {
        const json = JSON.parse(event.target.dataset.json);
        setNodeId(json.nodeId);
        setBrowseName(json.browseName);
        setNodeClass(json.nodeClass);
        setTypeDefinition(json.typeDefinition);
        setDataType(json.dataType);
        setDataValue(json.dataValue);
        console.log(json);
      } catch (error) {}
    }
  };

  const handleItem = item => {
    if (item) {
      const { organizes, hasComponent, ...properties } = item;
      return (
        <TreeItem
          nodeId={item.nodeId}
          label={item.browseName}
          onFocus={updateDetails}
        >
          <TreeItem
            nodeId={item.nodeId + "-nodeId"}
            label={"Node ID: " + item.nodeId}
            data-json={JSON.stringify(properties)}
          ></TreeItem>
          {item.organizes ? (
            item.organizes.map(subItem => handleItem(subItem))
          ) : (
            <div />
          )}
          {item.hasComponent ? (
            item.hasComponent.map(subItem => handleItem(subItem))
          ) : (
            <div />
          )}
        </TreeItem>
      );
    } else {
      return <div></div>;
    }
  };

  const getTree = async () => {
	setFetching(true);
	try {
		const response = await fetch("http://localhost:8086/api/v1.0/opcua", {
		  method: "POST",
		  headers: {
			"Content-Type": "application/json"
		  },
		  body: JSON.stringify({
			endpointURL
		  })
		});
		const data = await response.json();
		setFetching(false);
		setTree(data);
	} catch (error) {
		console.error(error);
		setFetching(false);
	}
  };

  return (
	<Grid container className={classes.root}>
		<Grid item xs={12}>
			<Typography variant="h5" gutterBottom>
				<FormattedMessage id="Extensions.OPCUA.PageTitle" defaultMessage="OPC UA Tree" />
			</Typography>
		</Grid>
      <Grid 
		container
		direction="row"
		alignItems="flex-end"
		xs={12}
	  >
	  	<Grid item xs={9}>
			<TextField
			disabled={fetching}
			id="endpoint-url"
			label="Endpoint URL"
			value={endpointURL}
			onChange={handleEndpointURLChange}
			/>
		</Grid>
		 <Grid item xs={3}>
			<Button disabled={fetching} color="primary" variant="contained" onClick={getTree}>
			Fetch OPC UA tree
			</Button>
		</Grid>
	  </Grid>
		<Grid container spacing={2}>
      		<Grid item xs={12}>
				{fetching && <CircularProgress />}
			</Grid>
			<Grid item xs={6}>
				{!fetching && <TreeView
				defaultCollapseIcon={<ExpandMoreIcon />}
				defaultExpandIcon={<ChevronRightIcon />}
				>
				{handleItem(tree.tree)}
				</TreeView>}
			</Grid>
			<Grid item xs={6} spacing={2}>
				<TableContainer>
				<Table size="small" >
					<TableRow>
						<TableCell>
						<strong>Node ID</strong>
						</TableCell>
						<TableCell>{nodeId}</TableCell>
						<TableCell align="right">
							<Button disabled={fetching} size="small" variant="contained" onClick={() => copy(nodeId)}>
								Copy node id
							</Button>
						</TableCell>
					</TableRow>
					<TableRow>
						<TableCell>
						<strong>Browse Name</strong>
						</TableCell>
						<TableCell colSpan={2}>{browseName}</TableCell>
					</TableRow>
					<TableRow>
						<TableCell>
						<strong>Node Class</strong>
						</TableCell>
						<TableCell colSpan={2}>{nodeClass}</TableCell>
					</TableRow>
					<TableRow>
						<TableCell>
						<strong>Type Definition</strong>
						</TableCell>
						<TableCell colSpan={2}>{typeDefinition}</TableCell>
					</TableRow>
					<TableRow>
						<TableCell>
						<strong>Data Type</strong>
						</TableCell>
						<TableCell colSpan={2}>{dataType}</TableCell>
					</TableRow>
					<TableRow>
						<TableCell>
						<strong>Data Value</strong>
						</TableCell>
						<TableCell colSpan={2}>{dataValue}</TableCell>
					</TableRow>
				</Table>
				</TableContainer>
			</Grid>
		</Grid>
      </Grid>
  );
}



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/opcua-webui-components/src/components/OPCUATree.js